<div class="paybee-modal-header px-4">
    <div class="row mb-3">
        <div class="col-11">
            <div class="code-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        <div class="col-1">
            <button (click)="close()" type="button" class="close">
                <svg class="cursor--pointer" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" fill="none">
                    <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>    
    </div>    

    <div class="row">
        <div class="col-12">
            <div class="modal-heading mb-1">Embed Campaign</div>
        </div>
        <div class="col-12">
            <div class="modal-sub-heading">{{title}}</div>
        </div>
    </div>
</div>
<div class="modal-body new-design-controls custom-material-form updated-dropdown pt-0 px-4">
    <mdb-tabs #tabs class="mdb-tabs mdb-tabs--new-design">
        <mdb-tab [formGroup]="themeForm" title="Settings">
            <div class="row pt-4">
                <div class="col-4 d-flex flex-column">
                    <span class="control-subtitle">Embed Type</span>
                    <mdb-form-control class="form-fill">
                        <mdb-select formControlName="type" class="mdb-select">
                            <mdb-option *ngFor="let type of types" [value]="type.id">{{type.label}}</mdb-option>
                        </mdb-select>
                    </mdb-form-control>

                    <div class="control-title mb-2">{{type.value === 1 ? 'Button' : 'Form'}} Settings</div>

                    <div class="settings-container">
                        @if(type.value === 1) {
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <span class="control-subtitle">Background Color</span>
                                <div class="d-flex">
                                    <input formControlName="buttonBgColor" type="color" class="form-control form-control-color">
                                </div>
                            </div>
                            
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="control-subtitle">Text Color</span>
                                <input formControlName="buttonTextColor" type="color" class="form-control form-control-color">
                            </div>
                        }
                        @if(type.value === 2) {
                            <!-- <div class="d-flex align-items-center justify-content-between mb-3">
                                <span class="control-subtitle">Background Color</span>
                                <input formControlName="formBgColor" type="color" class="form-control form-control-color">
                            </div> -->
                            
                            <div class="">
                                <span class="control-subtitle">Height</span>
                                <mdb-form-control class="form-fill mb-0">
                                    <app-mdbp-input (blur)="onFormHeightBlur()" mdbInput formControlName="formHeight" [isCurrencyMask]="true">
                                        <input  #inputNameC currencyMask formControlName="formHeight" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" class="form-control form-control--paybee"/>
                                    </app-mdbp-input>
                                </mdb-form-control>
                            </div>
                                
                                <!-- <div class="d-flex align-items-center mt-1">
                                    <label class="form-label form-label-colorpicker">Option Name Color:</label>
                                    <input formControlName="optionNameColor" type="color" class="form-control form-control-color">
                                </div>
            
                                <div class="d-flex align-items-center mt-1">
                                    <label class="form-label form-label-colorpicker">Card Background Color:</label>
                                    <input formControlName="cardBgColor" type="color" class="form-control form-control-color">
                                </div>
            
                                @if(!isMultipleTicketing) {
                                    <div class="d-flex align-items-center mt-1">
                                        <label class="form-label form-label-colorpicker">Select button Color:</label>
                                        <input formControlName="selectBtnBgColor" type="color" class="form-control form-control-color">
                                    </div>
                                } -->
                                <!-- @else {
                                    <div class="d-flex align-items-center mt-1">
                                        <label class="form-label form-label-colorpicker">Select buttons Color:</label>
                                        <input formControlName="selectButtonsBgColor" type="color" class="form-control form-control-color">
                                    </div>
                                } -->
                        }
                    </div>
                    
                </div>
                <div class="col-8 pl-4">
                    <div class="control-subtitle mb-2">Live Preview</div>
                    <div class="preview-area">
                        @if(type.value === 1) {
                            <app-button [text]="getDonationButtonLabel()" [theme]="donationButtonTheme"></app-button>
                        }
                        @if(type.value === 2) {
                            <app-iframe [handle]="data.handle" [ppid]="data.campaign.intid" [theme]="formThemeBase64" class="h-100"></app-iframe>
                        }
                    </div>
                </div>
            </div>

        </mdb-tab>
        <mdb-tab title="View Code">
            <textarea [formControl]="embedded" class="mt-4 w-100" rows="10" style="height: 150px;"></textarea>
        </mdb-tab>
    </mdb-tabs>
</div>

<div class="d-flex px-4 pb-4 mt-3">
    <button (click)="close()" type="button" class="modal-button modal-button--outline mr-2">Close</button>
    <button (click)="onCopy()" [cdkCopyToClipboard]="embedded.value" type="button" class="modal-button">
        <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_4658_8912)">
              <path d="M13.3332 13.3337V15.667C13.3332 16.6004 13.3332 17.0671 13.1515 17.4236C12.9917 17.7372 12.7368 17.9922 12.4232 18.152C12.0666 18.3337 11.5999 18.3337 10.6665 18.3337H4.33317C3.39975 18.3337 2.93304 18.3337 2.57652 18.152C2.26292 17.9922 2.00795 17.7372 1.84816 17.4236C1.6665 17.0671 1.6665 16.6004 1.6665 15.667V9.33366C1.6665 8.40024 1.6665 7.93353 1.84816 7.57701C2.00795 7.2634 2.26292 7.00844 2.57652 6.84865C2.93304 6.66699 3.39975 6.66699 4.33317 6.66699H6.6665M9.33317 13.3337H15.6665C16.5999 13.3337 17.0666 13.3337 17.4232 13.152C17.7368 12.9922 17.9917 12.7372 18.1515 12.4236C18.3332 12.0671 18.3332 11.6004 18.3332 10.667V4.33366C18.3332 3.40024 18.3332 2.93353 18.1515 2.57701C17.9917 2.2634 17.7368 2.00844 17.4232 1.84865C17.0666 1.66699 16.5999 1.66699 15.6665 1.66699H9.33317C8.39975 1.66699 7.93304 1.66699 7.57652 1.84865C7.26292 2.00844 7.00795 2.2634 6.84816 2.57701C6.6665 2.93353 6.6665 3.40024 6.6665 4.33366V10.667C6.6665 11.6004 6.6665 12.0671 6.84816 12.4236C7.00795 12.7372 7.26292 12.9922 7.57652 13.152C7.93304 13.3337 8.39975 13.3337 9.33317 13.3337Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_4658_8912">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
        </svg>
        Copy Embed Code
    </button>
</div>